// Whiteboard — frontend API surface (/api/whiteboard, server/routes.js).

import { client } from '@platform/http/api-client';

const enc = encodeURIComponent;
const data = (p) => p.then((r) => r.data);

const whiteboardApi = {
  board: (key, fieldId) => data(client.get(`/api/whiteboard/issue/${enc(key)}/field/${enc(fieldId)}`)),
  save: (key, fieldId, elements, clientId) => data(client.post(`/api/whiteboard/issue/${enc(key)}/field/${enc(fieldId)}/elements`, { elements, clientId })),
  upload: (key, fieldId, { id, blob, name, width, height }) => data(client.post(
    `/api/whiteboard/issue/${enc(key)}/field/${enc(fieldId)}/files`, blob, {
      headers: {
        'Content-Type': blob.type || 'application/octet-stream',
        'X-File-Id': id,
        'X-File-Name': encodeURIComponent(name || ''),
        'X-Image-Width': String(width || ''),
        'X-Image-Height': String(height || ''),
      },
      timeout: 300000,
    },
  )),
  file: (id) => client.get(`/api/whiteboard/files/${enc(id)}`, { responseType: 'blob', timeout: 120000 }).then((r) => r.data),
  // the work item's own PDFs and pictures, and putting one on the board
  attachments: (key, fieldId) => data(client.get(`/api/whiteboard/issue/${enc(key)}/field/${enc(fieldId)}/attachments`)),
  fromAttachment: (key, fieldId, attachmentId) => data(client.post(`/api/whiteboard/issue/${enc(key)}/field/${enc(fieldId)}/from-attachment`, { attachmentId }, { timeout: 300000 })),
  // another page of a PDF already on the board
  pdfPage: (key, fieldId, pdfFileId, page) => data(client.post(`/api/whiteboard/issue/${enc(key)}/field/${enc(fieldId)}/pdf-page`, { pdfFileId, page }, { timeout: 300000 })),
  // a file from this device, attached to the work item (the work item's own attachment route)
  attach: (key, file) => {
    const form = new FormData();
    form.append('file', file);
    return data(client.post(`/api/issue/${enc(key)}/attachments`, form, { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 300000 }));
  },
  attachmentThumb: (attachmentId) => client.get(`/api/attachment-thumb/${enc(attachmentId)}`, { responseType: 'blob' }).then((r) => r.data),
};

export default whiteboardApi;
